import React from 'react';
import { useNavigate } from 'react-router-dom';

import { SvgCardType } from '../../components/svg-card/svg-card-types';
import { useConfig } from '../../config';
import { urler } from '../../router/router-urler';
import { RadioAlternativ } from '../../sporsmalsflyt/reducer/sporsmalsflyt-types';
import { Skademeldingstype } from '../../types/generated-types';
import { navigateToSitecorePage, skadeUrlFromSkadetype } from '../../urler';
import { GruppeLandingsside } from '../gruppe-landingsside';
import { KategoriSvarId } from '../sporsmal-og-svar';

const { reiseMistetSkadetStjaletUrl, reiseSykdomUlykkeDodsfallUrl, rettshjelpUrl, ansvarUrl } = urler();

const alternativer: RadioAlternativ[] = [
    {
        id: KategoriSvarId.AvbestillingEllerOmbooking,
        tekst: 'Avbestilling eller ombooking før reisens start',
    },
    {
        id: KategoriSvarId.ForsinketBagasje,
        tekst: 'Forsinket bagasje',
    },
    {
        id: KategoriSvarId.ForsinketTransport,
        tekst: 'Forsinkelse på reise',
    },
    {
        id: KategoriSvarId.AndreSkaderUnderReise,
        tekst: 'Mistet, skadet eller stjålet reisegods',
    },
    {
        id: KategoriSvarId.ReiseSykdomUlykkeEllerDodsfallPaReisen,
        tekst: 'Sykdom, ulykke eller dødsfall på reisen',
    },
    {
        id: KategoriSvarId.Rettshjelp,
        tekst: 'Rettshjelp',
    },
    {
        id: KategoriSvarId.Ansvar,
        tekst: 'Ansvar',
    },
];

export const Reise = () => {
    const { url } = useConfig().links.reiselandingsside;
    const navigate = useNavigate();

    const onNext = (svarId: KategoriSvarId) => {
        if (svarId === KategoriSvarId.AvbestillingEllerOmbooking) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.Reiseavbestilling));
        } else if (svarId === KategoriSvarId.ForsinketBagasje) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.ForsinketBagasje));
        } else if (svarId === KategoriSvarId.ForsinketTransport) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.ForsinketTransport));
        } else if (svarId === KategoriSvarId.AndreSkaderUnderReise) {
            navigate(reiseMistetSkadetStjaletUrl);
        } else if (svarId === KategoriSvarId.ReiseSykdomUlykkeEllerDodsfallPaReisen) {
            navigate(reiseSykdomUlykkeDodsfallUrl);
        } else if (svarId === KategoriSvarId.Rettshjelp) {
            navigate(rettshjelpUrl);
        } else if (svarId === KategoriSvarId.Ansvar) {
            navigate(ansvarUrl);
        }
    };

    return (
        <GruppeLandingsside
            title="Reise"
            onNext={onNext}
            navigateToParent={() => navigateToSitecorePage(url)}
            alternativer={alternativer}
            svgCardType={SvgCardType.BagasjeFlyplass}
            kategoriId="reise"
        />
    );
};
